import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Comment } from '@ifeng-fe/three_terminal/es/pc/comment';
import Nav from '@src/pc/index/layout/Nav';
import MainNews from '@src/pc/index/layout/MainNews';
import Banner from '@src/pc/index/components/Banner';
import ArticleBox from '@src/pc/index/layout/ArticleBox';
import ImageArticleList from '@src/pc/index/layout/ImageArticleList';
import Tabs from '@src/pc/index/layout/Tabs';
import MainSwiper from '@src/pc/index/layout/MainSwiper';
import Support from '@src/pc/index/layout/Support';
import Footer from '@src/pc/index/layout/Footer';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';
import Ad from '@ifeng-fe/ui_pc_ad';
import { chipMap, adMap } from '../chipMap';
import Matirx from '@src/pc/index/layout/Matirx';
import Part from '@src/common/Part';

const Layout = ({ content }) => {
    const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';
    
    return (
        <div className={styles.layout}>
            <Chip key="layout" {...chipMap.layout}>
                <div className={styles.layoutSetting} />
            </Chip>
            <Chip key="mainImage" {...chipMap.mainImage}>
                <img className={styles.mainImage} src={content.mainImage} alt="主视觉" />
            </Chip>
            <Chip key="nav" {...chipMap.nav} content={content.nav}>
                <Nav />
            </Chip>
            <div className={styles.flow}>
                <Ad key="ad6" content={{ desc: adMap.ad6, ...content.ad6 }} />
            </div>
            <Part data={content.layout}>
                <div className={`${styles.box} ${styles.box1}`} id="box1">
                    <Ad key="ad8" content={{ desc: adMap.ad8, ...content.ad8 }} />
                    <MainNews content={content} />
                    <Ad key="ad5" content={{ desc: adMap.ad5, ...content.ad5 }} />
                </div>
                <div className={`${styles.box} ${styles.box2}`} id="box2">
                    <Chip key="bigBanner1" {...chipMap.bigBanner1}>
                        <Banner image={content.bigBanner1} />
                    </Chip>
                    <Chip key="articleBox1" {...chipMap.articleBox1} content={content.articleBox1}>
                        <ArticleBox />
                    </Chip>
                </div>
                <div className={`${styles.box} ${styles.box3}`} id="box3">
                    <Chip key="bigBanner2" {...chipMap.bigBanner2}>
                        <Banner image={content.bigBanner2} />
                    </Chip>
                    <Chip key="imageArticleList" {...chipMap.imageArticleList} content={content.imageArticleList}>
                        <ImageArticleList />
                    </Chip>
                </div>
                <div className={`${styles.box} ${styles.box4}`} id="box4">
                    <Chip key="bigBanner3" {...chipMap.bigBanner3}>
                        <Banner image={content.bigBanner3} />
                    </Chip>
                    <Chip key="tabs" {...chipMap.tabs} content={content.tabs}>
                        <Tabs />
                    </Chip>
                </div>
                <div className={`${styles.box5}`} id="box5">
                    <div className={styles.box}>
                        <Chip key="bigBanner4" {...chipMap.bigBanner4}>
                            <Banner image={content.bigBanner4} />
                        </Chip>
                    </div>
                    <Chip key="swiper" {...chipMap.swiper} content={content.swiper}>
                        <MainSwiper />
                    </Chip>
                </div>
                <div className={`${styles.box} ${styles.box6}`} id="box6">
                    <Chip key="bigBanner5" {...chipMap.bigBanner5}>
                        <Banner image={content.bigBanner5} />
                    </Chip>
                    <Chip key="articleBox2" {...chipMap.articleBox2} content={content.articleBox2}>
                        <ArticleBox />
                    </Chip>
                </div>
                <div className={`${styles.box} ${styles.box7}`} id="box7">
                    <Chip key="bigBanner6" {...chipMap.bigBanner6}>
                        <Banner image={content.bigBanner6} />
                    </Chip>
                    <Chip key="articleBox3" {...chipMap.articleBox3} content={content.articleBox3}>
                        <ArticleBox />
                    </Chip>
                </div>
                <div className={`${styles.box} ${styles.box8}`} id="box8">
                    <Chip key="bigBanner7" {...chipMap.bigBanner7}>
                        <Banner image={content.bigBanner7} />
                    </Chip>
                    <Chip key="matirx" {...chipMap.matirx} content={content.matirx}>
                        <Matirx />
                    </Chip>
                </div>
                <div className={`${styles.box} ${styles.box9}`} id="box9">
                    <Chip key="bigBanner8" {...chipMap.bigBanner8}>
                        <Banner image={content.bigBanner8} />
                    </Chip>
                    <Comment
                        articleInfo={{
                            noAd: true,
                            // 文章单页的页面地址 commentUrl
                            docUrl: 'https://news.ifeng.com/loc/special/2022qglh/',
                            // 文章的标题
                            docTitle: '2022全国两会',
                            // 文章评论的skey，这个是在后端生成好后给到前端的，个性化页面没有skey的话，可以为空
                            skey: '',
                            // 兼容以后的专题评论
                            speUrl: '',
                            // 文章pc的页面地址
                            pcUrl: '',
                            // 获取评论内容接口
                            cmtNumUrl: `https://${ commentDomain }/get.php`,
                            // 评论内容字数长度
                            cmtLength: 1000,
                            // 提交评论内容接口
                            cmtPostUrl: `https://${ commentDomain }/post.php`,
                            // 最热评论数量
                            hotLimit: 2,
                            // 推荐评论接口
                            cmtVoteUrl: `https://${ commentDomain }/vote.php`,
                            // 现实回复的楼层
                            replyLimit: 3,
                            // 举报提交接口
                            jubUrl: `https://${ commentDomain }/report`,
                            // 举报次数，便于每次回调函数名不同
                            jubNum: 0,
                            // 是否是评论详情页面
                            isComment: false,
                            // docUrl: "ucms_86YOkEdIiC1"
                        }}
                    />
                </div>
                <div className={`${styles.box} ${styles.box10}`} id="box10">
                    <Chip key="bigBanner9" {...chipMap.bigBanner9}>
                        <Banner image={content.bigBanner9} />
                    </Chip>
                    <Chip key="support" {...chipMap.support} content={content.support}>
                        <Support />
                    </Chip>
                </div>
                <Ad key="ad1" content={{ desc: adMap.ad1, ...content.ad1 }} id="ad1" />
                <Ad key="ad2" content={{ desc: adMap.ad2, ...content.ad2 }} id="ad2" />
                <Ad key="ad3" content={{ desc: adMap.ad3, ...content.ad3 }} id="ad3" />
                <Ad key="ad4" content={{ desc: adMap.ad4, ...content.ad4 }} id="ad4" />
            </Part>
            <Footer />
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
